<script setup lang="ts">
import Dialog from '@jaaluu/components/Dialog.vue';
import stores from '@jaaluu/stores';
import { t } from '@shared/i18n';
import { LanguageLevel } from '@shared/openapi/jaaluu-api';
import { nextTick, watch } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const { levelSettingsOpen } = stores.settings.state;
const { langLevel, langForeign } = stores.language.state;
const { setLangLevelToLocalStore } = stores.language.funcs;
const { switchFavoriteGroup } = stores.favorites.funcs;

watch(
  () => langLevel.value,
  (newLevel: LanguageLevel) => {
    setLangLevelToLocalStore(langLevel.value);
    if (newLevel !== LanguageLevel.A1_A2) {
      switchFavoriteGroup('default');
    }
    router.push(`/${langForeign.value}`);
    // Wait a tick so the v-select's own menu-close update finishes before the
    // parent v-dialog is torn down, otherwise both teleported overlays unmount
    // in the same flush and Vue throws "insertBefore" on a null parent.
    nextTick(() => {
      levelSettingsOpen.value = false;
    });
  }
);
</script>

<template>
  <Dialog
    v-model="levelSettingsOpen"
    :max-width="400"
    @close="() => (levelSettingsOpen = false)"
    :title="t('general.settings')"
  >
    <v-select
      v-model="langLevel"
      :items="Object.values(LanguageLevel)"
      :label="t('general.level')"
      variant="underlined"
      color="green"
      class="mt-8 w-300"
      hide-details
    />

  </Dialog>
</template>
<style lang="scss" scoped></style>
